module.exports = __webpack_public_path__ + "img/sv45on.67df7456.svg";